import MasterRoleImportPage from './MasterRoleImportPage';

export default MasterRoleImportPage;
